import ArrowRight2 from '@assets/icons/arrow-right2.svg'
import { Icon } from './Icon'

export const ArrowRight2Icon = Icon(ArrowRight2)
